import { createContext, useContext, type PropsWithChildren } from "react";

export type ScoutHost = "full-page" | "popover";

export type ScoutHostContextValue = {
  host: ScoutHost;
  /** Dismiss popover without resetting conversation (representative handoff). */
  closeScout?: () => void;
};

const ScoutHostContext = createContext<ScoutHostContextValue>({ host: "full-page" });

export function ScoutHostProvider({
  value,
  children,
}: PropsWithChildren<{ value: ScoutHostContextValue }>) {
  return <ScoutHostContext.Provider value={value}>{children}</ScoutHostContext.Provider>;
}

export function useScoutHostContext(): ScoutHostContextValue {
  return useContext(ScoutHostContext);
}
